// extracted by mini-css-extract-plugin
module.exports = {"evetInfoDetails__details_container":"EventInfoDetails_evetInfoDetails__details_container__352p6","event_image":"EventInfoDetails_event_image__eszXd"};